import { Grid, Typography } from "@mui/material";
import { GradientButtonOutline } from "components/GradientButton";
import React, { useState } from "react";
import SearchBar from "components/TableExplanded/SearchBar";
import api from "_api";
import CustomTable from "components/TableExplanded/Table";
import useColumns from "./columns/mainColumns";
import useColumnsTwo from "./columns/subColumns";
import useProductData from "./data/data";
import CustomPagination from "components/TableExplanded/Pagination";
import SaveIcon from "@mui/icons-material/Save";
import Modal from "components/Modal/SuperAdmin/create/createUser";
import ViewModal from "components/Modal/SuperAdmin/view/ViewUsers";

const Users = ({ className }) => {
  const [searchTerm, setSearchTerm] = React.useState("");
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isViewModalOpen, setViewModalOpen] = React.useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = React.useState(false);
  const [selectedProduct, setProduct] = React.useState(null);
  const [viewProduct, setViewProduct] = React.useState(null);
  const [selectedUserDelete, setSelectedUserDelete] = React.useState();
  const [fetchData, setFetchData] = React.useState();
  const [searchQuery, setSearchQuery] = React.useState(""); // Store the search query
  const [dataLength, setDataLength] = useState(0);

  const handleViewOpen = () => {
    setViewModalOpen(!isViewModalOpen);
    if (viewProduct && isViewModalOpen) setViewProduct(null);
  };

  const handleModalOpen = () => {
    setIsModalOpen(!isModalOpen);
    if (selectedProduct && isModalOpen) setProduct(null);
  };

  const handleDeleteOpen = () => {
    setIsDeleteModalOpen(!isDeleteModalOpen);
    if (selectedProduct && isDeleteModalOpen) setProduct(null);
  };

  const fetchProductData = async ({ search = "", page = 1, limit = 10 }) => {
    try {
      const { data, isStatus,total } = await api.super_admin.getUsers({ search, page, limit });
      if (isStatus) {
        setFetchData(data);
        setDataLength(total); // Set the total data length for pagination
      }
    } catch (error) {
      console.error("Error fetching product data:", error);
    }
  };
  React.useEffect(() => {
    fetchProductData({ search: searchQuery, page: page + 1, limit: rowsPerPage });
  }, [searchQuery, page, rowsPerPage]);
  const data = useProductData(fetchData);
  const columns = useColumns(
    setViewProduct,
    setProduct,
    handleViewOpen,
    handleModalOpen,
    fetchData,
    fetchProductData
  );
  const columnsInside = useColumnsTwo();
  const visibleColumns = columns.filter((col) => col.showInFilter);

  // const filteredData = React.useMemo(() => {
  //   if (!searchQuery) return data; // If no search query, return all data

  //   return data.filter((row) => {
  //     return visibleColumns.some((column) => {
  //       const cellValue = row[column.accessor]?.toString()?.toLowerCase();
  //       return cellValue && cellValue.includes(searchQuery.toLowerCase());
  //     });
  //   });
  // }, [data, searchQuery, visibleColumns]);

  const handleSearchChange = (event) => {
    if (event && event.target && event.target.value !== undefined && event.target.value !== null) {
      const query = event.target.value.toLowerCase();
      setSearchTerm(query);
      setSearchQuery(query); 
    } else {
      console.error("Event target or value is undefined");
    }
    setPage(0); 
  };

  const handleClear = () => {
    setSearchTerm("");
    setPage(0);
    fetchProductData({ search: "", page: 1, limit: rowsPerPage })
    
  };

  const handlePageChange = (event, newPage) => {
    if(searchTerm != null)
      {
        setSearchQuery(searchTerm.order_code)
      }
      setPage(newPage);
  };

  const handleRowsPerPageChange = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  return (
    <div className={className}>
      <Grid container spacing={2} style={{ marginBottom: "16px" }}>
        <Grid
          item
          xs={12}
          sm={12}
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Typography component="div" style={{ fontSize: "32px" }}>
            ผู้ใช้งาน
          </Typography>
          <Grid display={"flex"} style={{ gap: "8px" }}>
            <GradientButtonOutline
              sx={{
                px: 3,
                display: "flex",
                alignItems: "center",
                height: "48px",
              }}
            >
              <Typography style={{ marginRight: "8px" }}>
                ส่งออก Excel
              </Typography>
              <SaveIcon fontSize="medium" />
            </GradientButtonOutline>
          </Grid>
        </Grid>
      </Grid>

      <SearchBar
        columns={columns}
        searchTerm={setSearchTerm}
        visibleColumns={visibleColumns} // กรองคอลัมน์ที่ต้องการแสดง
        handleSearchChange={handleSearchChange}
        handleClear={handleClear}
        fetchData={fetchData}
        handleSearchClick={(filters) =>{
          fetchProductData({ search: filters.search || "", page: 1, limit: rowsPerPage })
        }}
      />

      <CustomTable
        columns={columns}
        columnsInside={columnsInside}
        searchTerm={searchTerm}
        data={data}
        page={page}
        rowsPerPage={rowsPerPage}
        setDataLength={setDataLength}
      />
      <CustomPagination
        count={dataLength}
        page={page}
        rowsPerPage={rowsPerPage}
        onPageChange={handlePageChange}
        onRowsPerPageChange={handleRowsPerPageChange}
      />

      <Modal
        open={isModalOpen}
        onClose={handleModalOpen}
        selectedProduct={selectedProduct}
        fetchProductData={() => fetchProductData({ search: searchQuery, page: page + 1, limit: rowsPerPage })}
        disableBackdropClick // Prevent clicking outside
        disableEscapeKeyDown // Prevent pressing `Esc`
      />

      <ViewModal
        open={isViewModalOpen}
        onClose={handleViewOpen}
        selectedProduct={viewProduct}
      />
    </div>
  );
};
export default Users;
